<template>
  <div class="city-wrapper">

    <!--<fixed-popup/>-->
    <subpage-header :city-icon="cityDetails ? cityDetails.icon : null">
<div slot="bread">
<ul itemscope itemtype="http://schema.org/BreadcrumbList">
<li class="mytitle1 myli" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
<a href="https://holywoodskyline.com/" class="" itemtype="https://schema.org/Thing" itemprop="item">
<span itemprop="name">holywoodskyline.com</span>
<span class="color-white"> / </span>
</a>
<meta itemprop="position" content="1" />
</li>

<li class="color-white mytitle1 myli" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
<a :href="city_url" class="" itemtype="https://schema.org/Thing" itemprop="item">
&nbsp;<span itemprop="name">{{ this.$route.params.genre }} Movies</span>
</a>
<meta itemprop="position" content="2" />
</li>
</ul>
</div>
<!--     <div class="vld-parent">
        <loading :active.sync="isLoading"
        :can-cancel="true"
        :on-cancel="onCancel"
        :is-full-page="fullPage"></loading>
    </div> -->
      <span slot="title" v-if="cityDetails" v-html="pageTitle"></span>
      <div class="city-text" slot="text" style="color: #fff;
    font-size: 17px;
    opacity: 0.75;
    font-weight: 400;">
        <span v-if="cityDetails" v-html="spot"></span>
      </div>
      <div class="subpage-header-inf" slot="numbers">
        <div class="subpage-header-inf__item">
          <img src="@/assets/img/icon-uni.svg" alt="" class="subpage-header-inf__icon icon">
          <div class="subpage-header-inf__cnt">
            <strong class="color-light-green d-block" v-if="cityDetails">{{ total_results }}</strong>
            <span>Movies</span>
          </div>
        </div>

<!--         <div class="subpage-header-inf__item">
          <img src="@/assets/img/icon-dorm.svg" alt="" class="subpage-header-inf__icon icon">
          <div class="subpage-header-inf__cnt">
            <strong class="color-light-green d-block" v-if="cityDetails">{{ cityDetails.dorms_count }}</strong>
            <span>Active Movie</span>
          </div>
        </div> -->
      </div>
    </subpage-header>
    <div class="subpage__inner">
      <div class="city-uni" style="padding-bottom: 65px;">
        <container>
          <div class="city-uni__wrp">
            <div class="section__header">
              <h2 class="section__title mb-0" v-if="cityDetails"><span class="color-light-green">Best </span>
                {{ this.$route.params.genre }} Studios </h2>
              <div class="section__right">
                <v-link
                  :to="{ name: 'CityDetailUnivercities' }"
                  title="Tüm Üniversiteleri Gör"
                  class="button--text mr-15 mobile-all"
                  v-if="cityDetails && cityDetails.universities && cityDetails.universities.length > 7"
                />
                <v-button
                  icon="icon-arrow-left"
                  icon-position="left"
                  class="circle white icon-xs xs js-uni-slider-prev"
                />
                <v-button
                  icon="icon-arrow-right"
                  icon-position="left"
                  class="circle white icon-xs xs js-uni-slider-next"
                />
              </div>
            </div>
            <swiper class="city-uni-slider" :options="swiperOption">
              <swiper-slide v-for="studio in getStudios" :key="studio.id" class="city-uni-slider__item">
                <router-link :to="{ name: 'Studio', params: { slug: studio.slug }}">
                  <uni-card :uni="studio"/>
                </router-link>
              </swiper-slide>
            </swiper>
          </div>

        </container>
      </div>

      <div class="gen" ref="dormTab">
        <container>
          <div class="dorm-tab">
            <div class="dorm-tab__header">
              <DormTabNav :tabs="tabs"/>

              <!--<div class="mobile-dropdown" @click="edit">-->
                <!--<span class="filtre">-->
                    <!--<svg-icon type="icon-filter"/>-->
                <!--</span>-->
                <!--<select-box title="Filtre Movies"/>-->
              <!--</div>-->
              <!--<div class="section__right" v-if="show">-->
                <!--<div class="section__select">-->
                  <!--<select-box :options="cities" title="Şehir Seçiniz"/>-->
                <!--</div>-->

                <!--<div class="section__select">-->
                  <!--<select-box :options="dormTypes" title="Yurt Tipi Seçiniz"/>-->
                <!--</div>-->
              <!--</div>-->

              <div class="desktop-drop">
                <div class="section__right">
                  <div class="section__select" v-if="cityDetails">
                     <VueSelectTempCity  placeholder="Select District" :options="cityDetails.districts" @onselect="selectDistrict"/>
                  </div>
                </div>
              </div>
            </div>
            <router-view/>
          </div>
        </container>
      </div>
      <container>
        <div class="seo-text" v-if="cityDetails">
          <p v-html="getlistseo"></p> <br>
          <v-link
            class="button--more color-white subpage-header__btn seo-btn"
            :title="' Agout the genre' + cityDetails.name"
            icon="icon-arrow-long-right"
            icon-position="right"
            :to="{ name: 'CityDetailAbout', params: { id: this.$route.params.id, slug: this.$route.params.city }}"
            slot="button"
          />
        </div>
      </container>              
    </div>
   <!-- Fixed Button -->
<!--        <v-button v-if="showGetPrice"
        class="button green round getBid my"
        icon="icon-fiyat-sor"
        icon-position="left"
        title="Yurtlar Beni Arasın"
        @click.native="showSmsModal()"
      /> -->
<!-- Fixed Button End -->
<Modal2 :active="showSuccessMessage" @onModalClose="closeModal2">
   <div slot="content">
     <div class="login-box" style="margin: 0 auto">
    <h2 class="login-box__title" >MESAJINIZ GÖNDERİLDİ!</h2>
    <div class="or">
      <!-- <img src="@/assets/img/mail-icon.png" class="preloader-svg" width="40"> -->
      <p ><span class= "mycolorBlue">İlginiz İçin Teşekkür Ederiz.</span></p>
      <p ><span class= "mycolorBlue">Arkadaşlarımız en yakın zamanda sizinle iletişime geçecek.</span></p>
    </div>
     </div>
</div>
</Modal2>
         <Modal2 :active="showModal" @onModalClose="closeModal">
          <div slot="content">
        <div class="dorm-form__inner mydorm-form-inner ">
          <div class="dorm-form__form">
              <div class="dorm-form-tab">
                    <div icon="icon-mail" class="dorm-form-tab__item mycolor mycursor1">
                        <svg viewBox="0 0 20 20" class="icon" style="font-size: 30px; color: rgb(235, 96, 129);">
                            <use xlink:href="/icon/icons.svg#icon-fiyat-sor"></use>
                        </svg>
                        <div class="dorm-form-tab__title">SHOW ME PRICES</div>
                        <!-- <div class="dorm-form-tab__title">{{ smsarea }} SHOW ME PRICES</div> -->
                    </div>
                </div> 
             <div id="my-form" ref="myMessageForm" >
             <v-input ref="myInput"  placeholder="Fullname" v-model="messageForm.name" v-on:keyup.native="saveForm"/>
            <label for="password" v-if="emptyName" class="myValidationText">Bu kısım boş geçilemez!</label>
             <v-select v-if="messageForm.university_name === 'Select Studio' || messageForm.university_name === null || messageForm.university_name ===''" :options="universities" placeholder="Üniversite Seç"  @onselect="selectUniversity"/>
             <VueSelectTempCity v-else :options="universities" placeholder="Select Studio"  @onselect="selectUniversity"/>
             <label for="password" v-if="emptyUniversity" class="myValidationText">Bu kısım boş geçilemez!</label>
             <VueSelect2 v-if="messageForm.faculty_name === 'Select Studio' && messageForm.university_name !='Üniversite Seç'" :options="faculties" placeholder='Fakülte Seç' @onselect="selectFaculty"/>
            <VueSelectTempFaculty v-else-if="facultyEnabled && messageForm.faculty_name !='Select Studio'" placeholder="Fakülte Seç" :options="faculties"  @onselect="selectFaculty"/>
            <SelectBox2 v-else myplaceholder="Select Studio" :options="faculties" :title="messageForm.faculty_name" @onselect="selectFaculty" disabled/>
            <label for="password" v-if="emptyFaculty" class="myValidationText">Bu kısım boş geçilemez!</label>
             <VueInputRestricted  placeholder="Telefon No" v-on:keyup.native="saveForm" v-model="messageForm.phone"/>
             <label for="phone" v-if="emptyPhone" class="myValidationText">Bu kısım boş geçilemez!</label>
             <label for="phone" v-if="falsePhone" class="myValidationText">Telefon numarası 0 ile başlamalıdır!</label>
             <label for="phone" v-if="shortPhone" class="myValidationText">Telefon numarası 11 hane olmalıdır!</label>
             <v-input type="text" placeholder="E-Posta Adresi" v-on:keyup.native="saveForm" v-model="messageForm.email"/>
              <label for="password" v-if="falseEmail" class="myValidationText">Geçersiz e-posta formatı!</label>
              <label for="password" v-if="emptyEmail" class="myValidationText">Bu kısım boş geçilemez!</label>
              </div>
             <v-button
               class="red fw mt-15 dorm-form__submit"
               title="SEND"
               @click.native="sendSmsAll()"
             />
           </div>

          </div>
        </div>
        </Modal2>
  </div>
</template>

<script>
import SubpageHeader from '@/components/SubpageHeader'
import UniCard from '@/components/UniCard'
import FixedPopup from '@/components/FixedPopup'
import SelectBox from '@/components/SelectBox'
import DormTabNav from '@/components/City/DormTabNavCity'
import Modal2 from '@/components/Modal2'
import VueInputRestricted from '@/components/VueInputRestricted'
import SelectBox2 from '@/components/SelectBox2'
import axios from 'axios'
import { mapGetters } from 'vuex'
import {
  GET_CITY_DETAILS
} from '@/store/actions.type'
import Loading from 'vue-loading-overlay'
import VueSelectTempCity from '@/components/VueSelectTempCity'
import VueSelectTempFaculty from '@/components/VueSelectTempFaculty'
import VueSelect2 from '@/components/VueSelect2'
export default {
  name: 'City',
  components: {
    SubpageHeader, UniCard, SelectBox, SelectBox2, FixedPopup, DormTabNav, Modal2, VueInputRestricted, Loading, VueSelectTempCity, VueSelectTempFaculty, VueSelect2
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.cityDetails ? this.cityDetails.detail_title : '',
      meta: [
        { vmid: 'description', name: 'description', content: this.cityDetails ? this.cityDetails.detail_description : '' },
        { vmid: 'keywords', name: 'keywords', content: this.cityDetails ? this.cityDetails.detail_keywords : '' }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: window.location.origin + this.fullPath } // this.page_url }
      ]
    }
  },
  data () {
    return {
      list_seo: '',
      fullPath: '',
      facultyEnabled: false,
      showSuccessMessage: false,
      smsarea: '',
      list: '',
      list_id: '',
      city_name: '',
      city_id: '',
      isLoading: false,
      fullPage: true,
      city_url: '',
      page_url: '',
      universities: [],
      faculties: [],
      showGetPrice: true,
      messageForm: {
        dorm_id: null,
        name: null,
        email: null,
        university_id: null,
        faculty_id: null,
        phone: null,
        university_name: 'Üniversite Seç',
        faculty_name: 'Fakülte Seç'
      },
      showModal: false,
      falseEmail: false,
      falsePhone: false,
      shortPhone: false,
      emptyName: false,
      emptyPhone: false,
      emptyEmail: false,
      emptyEmail2: false,
      emptyUniversity: false,
      emptyFaculty: false,
      currentRouteName: '',
      tabs: [
        {
          id: 2,
          typeID: 2,
          cat: 'female',
          title: '<span class="color-pink">See <literal> Movies </literal>',
          icon: require('@/assets/img/Old-Video-Cam-icon.png'),
          active: false
        },
        {
          id: 1,
          typeID: 1,
          cat: 'male',
          title: '<span class="color-blue">See <literal> Tv Shows </literal>',
          icon: require('@/assets/img/TV-icon.png'),
          active: false
        }
      ],
      swiperOption: {
        slidesPerView: 4,
        speed: 500,
        spaceBetween: 20,
        breakpoints: {
          640: {
            slidesPerView: 1,
            centeredSlides: true

          },
          320: {
            slidesPerView: 1
          }
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.js-uni-slider-next',
          prevEl: '.js-uni-slider-prev'
        }
      },
      gender: null,
      district: 'İlçe Seçiniz',
      districtGender: null,
      opt: null,
      errors: [],
      currentDistrict: null,
      districts: [],
      studiosSciFi: [
    {
      id: 174,
      logo_path: "/IuAlhI9eVC9Z8UQWOIDdWRKSEJ.png",
      name: "Warner Bros. Pictures",
      origin_country: "US"
    },
    {
      id: 8805,
      logo_path: "/vrpvFCl4DqYk5npjTyPJ8amBgsA.png",
      name: "Industrial Light & Magic",
      origin_country: "US"
    },
    {
      id: 1,
      logo_path: "/o86DbpburjxrqAzEDhXZcyE8pDb.png",
      name: "Lucasfilm",
      origin_country: "US"
    },
      ],
    studiosWestern: [
    {
      id: 33,
      logo_path: "/8lvHyhjr8oUKOOy2dKXoALWKdp0.png",
      name: "Universal Pictures",
      origin_country: "US"
    },
    {
      id: 26727,
      logo_path: "/jeTxdjXhzgKZyLr3l9MllkTn3fy.png",
      name: "Universal Television",
      origin_country: "US"
    },
      ],
    studiosDocumentary: [
    {
      id: 3324,
      logo_path: "/16fY7pucCzn7WSOYxOGRHlAayL3.png",
      name: "BBC",
      origin_country: "GB"
    },
    {
      id: 10622,
      logo_path: "/oraLQgdaulLar3nDKUfIYGQyyuj.png",
      name: "Public Broadcasting Service",
      origin_country: "US"
    },
   {
      id: 3268,
      logo_path: "/tuomPhY2UtuPTqqFnKMVHvSb724.png",
      name: "HBO",
      origin_country: "US"
    },
    {
      id: 28320,
      logo_path: "/5UPGj1MwzrtxclRGTfeiQ1J0zVk.png",
      name: "Rocket Pictures",
      origin_country: "GB"
    },
    {
      id: 100944,
      logo_path: "/db1kI0iwxQM23LjYjIwJOSwr8bY.png",
      name: "Early Light Media",
      origin_country: "US"
    },                
    {
      id: 100298,
      logo_path: null,
      name: "Discovery",
      origin_country: ""
    },    
    ], 
      studiosHorror: [
{
  description: "",
  headquarters: "Vancouver, Canada",
  homepage: "",
  id: 35,
  logo_path: "/wxrHa3nZ1K4zo65p56991INkGo6.png",
  name: "Lions Gate Films",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "Los Angeles, California, USA",
  homepage: "",
  id: 829,
  logo_path: "/mzpAmEQ5P1gFvdRoNyCk9q8ngiv.png",
  name: "Vertigo Entertainment",
  origin_country: "US",
  parent_company: null
},
    {
      id: 3172,
      logo_path: "/kDedjRZwO8uyFhuHamomOhN6fzG.png",
      name: "Blumhouse Productions",
      origin_country: "US"
    },
    {
      id: 2061,
      logo_path: "/o9LbN33hRaj4qcebUv1bikyXeoB.png",
      name: "Twisted Pictures",
      origin_country: "US"
    },
    {
      id: 76907,
      logo_path: "/wChlWsVgwSd4ZWxTIm8PTEcaESz.png",
      name: "Atomic Monster",
      origin_country: "US"
    },
    {
      id: 41077,
      logo_path: "/1ZXsGaFPgrgS6ZZGS37AqD5uU12.png",
      name: "A24",
      origin_country: "US"
    },
    {
      id: 2481,
      logo_path: "/nVEP2IHCDOBOldgDL4SSufitN9.png",
      name: "Platinum Dunes",
      origin_country: "US"
    },
    {
      id: 3052,
      logo_path: null,
      name: "Troma Entertainment",
      origin_country: ""
    },
    {
      id: 11565,
      logo_path: null,
      name: "The Safran Company",
      origin_country: "US"
    },
    {
      id: 768,
      logo_path: null,
      name: "Ghost House Pictures",
      origin_country: "US"
    }    
      ],
      studios:[        
                {
  description: '',
  headquarters: 'San Francisco, California, USA',
  homepage: 'http://www.lucasfilm.com',
  id: 1,
  logo_path: '/o86DbpburjxrqAzEDhXZcyE8pDb.png',
  name: 'Lucasfilm',
  origin_country: 'US',
  parent_company: null
},
{
  description: "",
  headquarters: "Emeryville, California, USA",
  ho1mepage: "http://www.pixar.com",
  id: 3,
  logo_path: "/1TjvGVDMYsj6JBxOAkUHpPEwLf7.png",
  name: "Pixar",
  origin_country: "US",
},
{
  description: "",
  headquarters: "Hollywood, California, USA",
  homepage: "http://www.paramount.com/",
  id: 4,
  logo_path: "/fycMZt242LVjagMByZOLUGbCvv3.png",
  name: "Paramount",
  origin_country: "US",
},
{
  description: "Columbia Pictures Industries, Inc. (CPII) is an American film production and distribution company. Columbia Pictures now forms part of the Columbia TriStar Motion Picture Group, owned by Sony Pictures Entertainment, a subsidiary of the Japanese conglomerate Sony. It is one of the leading film companies in the world, a member of the so-called Big Six. It was one of the so-called Little Three among the eight major film studios of Hollywood's Golden Age.",
  headquarters: "Culver City, California, USA",
  homepage: "http://www.sonypictures.com",
  id: 5,
  logo_path: "/71BqEFAF4V3qjjMPCpLuyJFB9A.png",
  name: "Columbia Pictures",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "New York City, New York, USA",
  homepage: "",
  id: 6,
  logo_path: "/n53F7K9scQWFXYbrCablqLKqJdp.png",
  name: "RKO Radio Pictures",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "Universal City, California, USA",
  homepage: "http://dreamworkspictures.com",
  id: 7,
  logo_path: "/jCwNupLautLSk6iB28VXrDPUqD8.png",
  name: "DreamWorks Pictures",
  origin_country: "US",
  parent_company: null
}
      ],
studiosAnimation: [
{
  description: "",
  headquarters: "Emeryville, California, USA",
  ho1mepage: "http://www.pixar.com",
  id: 3,
  logo_path: "/1TjvGVDMYsj6JBxOAkUHpPEwLf7.png",
  name: "Pixar",
  origin_country: "US",
},
  {
  description: "",
  headquarters: " Burbank, California, USA",
  homepage: "http://www.marvel.com",
  id: 420,
  logo_path: "/hUzeosd33nzE5MCNsZxCGEKTXaQ.png",
  name: "Marvel Studios",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "Glendale, California, United States",
  homepage: "http://www.dreamworksanimation.com/",
  id: 521,
  logo_path: "/cHvwSfUAG1KPkiwdBDwtn5ahX0P.png",
  name: "DreamWorks Animation",
  origin_country: "US",
  parent_company: null
},
{
  description: "",
  headquarters: "Burbank, California, USA",
  homepage: "",
  id: 670,
  logo_path: "/rRGi5UkwvdOPSfr5Xf42RZUsYgd.png",
  name: "Walt Disney Animation Studios",
  origin_country: "US",
},
{
  description: "",
  headquarters: "Bristol, England",
  homepage: "http://www.aardman.com/",
  id: 297,
  logo_path: "/ykJbf1z5qIreJrHWfnh1ev1alkD.png",
  name: "Aardman Animations",
  origin_country: "GB",
  parent_company: null
},
    {
      id: 7899,
      logo_path: "/qnhd98hnBxCMMMod58FJqbCZ5O7.png",
      name: "Cartoon Network Studios",
      origin_country: "US"
    },
    {
      id: 23948,
      logo_path: "/uneZYGxTZcwAzmPTTaefmDNWPzN.png",
      name: "Cartoon Saloon",
      origin_country: "IE"
    },
    {
      id: 108270,
      logo_path: "/b34gQGmEWBm1NapuqEjBD6oNbWj.png",
      name: "Lucasfilm Animation",
      origin_country: "US"
    },
    {
      id: 5438,
      logo_path: "/nrvweD25GIYmfTIaFyIncLy4p3G.png",
      name: "Kyoto Animation",
      origin_country: "JP"
    },
    {
      id: 5542,
      logo_path: "/ayE4LIqoAWotavo7xdvYngwqGML.png",
      name: "Toei Animation",
      origin_country: "JP"
    },
    {
      id: 94584,
      logo_path: "/j42xbuQ7qxluv042zdeiKHZVfAq.png",
      name: "Oasis Animation",
      origin_country: "CA"
    },
    {
      id: 5542,
      logo_path: "/ayE4LIqoAWotavo7xdvYngwqGML.png",
      name: "Toei Animation",
      origin_country: "JP"
    },        
{
  description: "",
  headquarters: "Van Nuys, California, USA",
  homepage: "",
  id: 20,
  logo_path: null,
  name: "Rough Draft Studios",
  origin_country: null,
  parent_company: null
},
]

    }
  },
  methods: {
    saveForm () {
      window.localStorage.setItem('username', this.messageForm.name)
      window.localStorage.setItem('mail', this.messageForm.email)
      window.localStorage.setItem('phone1', this.messageForm.phone)
    },
    validateEmail (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    sendSmsAll () {
      this.falseEmail = false
      this.falsePhone = false
      this.shortPhone = false
      this.emptyName = false
      this.emptyPhone = false
      this.emptyEmail = false
      this.emptyUniversity = false
      this.emptyFaculty = false
      const verifiedMail = this.validateEmail(this.messageForm.email)
      var self = this
      if (this.isLogin === '') {
        this.universities.forEach((data) => {
          if (data.id == self.messageForm.university_id) {
            // self.university_name = data.name
            window.localStorage.setItem('university_name', data.name)
          }
        })
        if (this.messageForm.faculty_id && this.faculties) {
          this.faculties.forEach((data) => {
            if (data.id == self.messageForm.faculty_id) {
              // self.university_name = data.name
              window.localStorage.setItem('faculty_name', data.name)
            }
          })
        }
        /*                 window.localStorage.setItem('name', this.messageForm.name)
                window.localStorage.setItem('mail', this.messageForm.email)
                window.localStorage.setItem('phone1', this.messageForm.phone)
                window.localStorage.setItem('university_id', this.messageForm.university_id)
                window.localStorage.setItem('faculty_id', this.messageForm.faculty_id) */
      }

      if (!this.messageForm.email) {
        this.emptyEmail = true
      } else if (this.messageForm.email && !verifiedMail) {
        this.falseEmail = true
      }
      if (!this.messageForm.name) {
        this.emptyName = true
      }
      if (!this.messageForm.phone) {
        this.emptyPhone = true
      }

      if (this.messageForm.phone && !this.messageForm.phone.startsWith('0')) {
        this.falsePhone = true
      }

      if (this.messageForm.phone && !this.falsePhone && this.messageForm.phone.length != 11) {
        this.shortPhone = true
      }

      if (!this.messageForm.university_id || this.messageForm.university_id == 'null') {
        this.emptyUniversity = true
      }

      if (!this.messageForm.faculty_id || this.messageForm.faculty_id == 'null') {
        this.emptyFaculty = true
      }

      if (!this.emptyName && !this.emptyEmail && !this.falseEmail && verifiedMail && !this.emptyPhone && !this.falsePhone && !this.shortPhone && !this.emptyUniversity) {
        axios.post(`/site/dorm/message/multiple`, {
          email: this.messageForm.email,
          name: this.messageForm.name,
          phone: this.messageForm.phone,
          email: this.messageForm.email,
          university_id: this.messageForm.university_id,
          faculty_id: this.messageForm.faculty_id,
          list: this.list,
          list_id: this.list_id
        })
          .then(response => {
            //          this.isLoading = false
            this.closeModal()
            this.showSuccessMessage = true
          })
          .catch(e => {
            self.errors.push(e)
          })
      }
    },
    selectFaculty (opt) {
      this.messageForm.faculty_name = opt.name
      window.localStorage.setItem('faculty_id', opt.id)
      window.localStorage.setItem('faculty_name', opt.name)      
    },
    closeModal () {
      this.showModal = false
      this.showGetPrice = true
    },
    closeModal2 () {
      this.showSuccessMessage = false
    },
    showSmsModal () {
      this.getUniversities()
      if (this.district) {
        this.smsarea = this.opt.name.toUpperCase() + ' İLÇESİNDEKİ'
        this.list = 'district'
        this.list_id = this.opt.id
      } else {
        this.smsarea = this.city_name.toUpperCase() + ' ŞEHRİNDEKİ'
        this.list = 'city'
        this.list_id = this.city_id
      }
      if (!window.localStorage.getItem('mail') || window.localStorage.getItem('mail') === '' || window.localStorage.getItem('mail') === 'null') {
        this.messageForm.email = ''
      } else {
        this.messageForm.email = window.localStorage.getItem('mail')
      }
      if (!window.localStorage.getItem('username') || window.localStorage.getItem('username') === '' || window.localStorage.getItem('username') === 'null') {
        this.messageForm.name = ''
      } else {
        this.messageForm.name = window.localStorage.getItem('username')
      }
      if (!window.localStorage.getItem('phone1') || window.localStorage.getItem('phone1') === '' || window.localStorage.getItem('phone1') === 'null') {
        this.messageForm.phone = ''
      } else {
        this.messageForm.phone = window.localStorage.getItem('phone1')
        this.messageForm.university_id = window.localStorage.getItem('university_id')
        this.messageForm.faculty_id = window.localStorage.getItem('faculty_id')
      }
      if (!window.localStorage.getItem('university_name') || window.localStorage.getItem('university_name') === '' || window.localStorage.getItem('university_name') === 'null') {
        this.messageForm.university_name = 'Üniversite Seç'
        this.facultyEnabled = false
      } else {
        this.facultyEnabled = true
        let self = this
        axios.get(`/selected/faculties/${window.localStorage.getItem('university_id')}`)
          .then(response => {
            self.faculties = response.data
          })
        this.messageForm.university_name = window.localStorage.getItem('university_name')
      }

      if (!window.localStorage.getItem('faculty_name') || window.localStorage.getItem('faculty_name') === 'null' || window.localStorage.getItem('faculty_name') === 'null') {
        this.messageForm.faculty_name = 'Fakülte Seç'
      } else {
        this.messageForm.faculty_name = window.localStorage.getItem('faculty_name')
      }
      this.showModal = true
      this.showGetPrice = false
    },
    checkGender () {
      const type = (this.$attrs.redirect || false) ? this.$route.params.slug : this.$route.params.type
      if (type && type.includes('erkek')) {
        this.gender = 'Erkek'
        this.typeID = 1
      } else if (type && type.includes('kiz')) {
        this.gender = 'Kız'
        this.typeID = 2
      } else {
        this.gender = null
      }
    },
    checkDistrict () {
      if (!this.$route.params.district) {
        if (this.$route.fullPath.includes('ilcesi')) {
          this.district = 'empty' // ''this.$route.params.district
        } else {
          this.district = 'İlçe Seçiniz'
        }
      } else {
         //window.localStorage.setItem('district_name', this.$route.params.district)    
        // this.district = $route.params.district
      }
        if (this.$route.fullPath.includes('ilcesi')) {
          //this.district = 'empty' // ''this.$route.params.district
        } else {
          window.localStorage.setItem('district_name', '')
        }

    },
    checkCityDetails () {
      const slug = this.$route.params.city
      if (this.cityDetails) {
        if (this.cityDetails.slug !== slug) {
          this.$store.dispatch(GET_CITY_DETAILS, null)
          this.getCityDetails()
        }
      } else {
        this.getCityDetails()
      }
    },
    getCityDetails () {
      let self = this
      this.isLoading = true
      axios.get(`/3/discover/movie?api_key=a11ac97c6bdb99adc0845654be0902a8&with_genres=28&page=2`)
        .then(response => {
          this.isLoading = false

           self.$store.dispatch(GET_CITY_DETAILS, response.data)
           

          self.districts = response.data.districts.sort((a, b) => (a.name > b.name) ? 1 : -1)
          const allSelection = {id:5555, name: "Tüm İlçeler"}
          self.districts = response.data.districts.unshift(allSelection)

          self.city_name = response.data.name
          self.city_id = response.data.id
          self.city_url = window.location.origin + '/' + response.data.slug + '-movies/'
          self.page_url = window.location.origin + '/' + response.data.slug + '-movies/'
          // check again !
          self.cityDetails = response.data
        })
        .catch(e => {
          self.errors.push(e)
        })
    },
    getUniversities () {
      let self = this
      axios.get('/selected/universities')
        .then(response => {
          self.universities = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    selectUniversity (opt) {
      this.facultyEnabled = true
      this.messageForm.university_id = opt.id
      this.messageForm.university_name = opt.name
      window.localStorage.setItem('university_name', opt.name)
      window.localStorage.setItem('university_id', opt.id)
      let self = this
      axios.get(`/selected/faculties/${opt.id}`)
        .then(response => {
          self.faculties = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    selectFacultyOnForm (opt) {
      this.messageForm.faculty_name = opt.name
      window.localStorage.setItem('faculty_id', opt.id)
      window.localStorage.setItem('faculty_name', opt.name)
    },
    selectDistrict (opt) {
      this.district = true
      this.opt = opt
      const slug = this.$route.params.city
      window.localStorage.setItem('district_name', opt.name)
      window.localStorage.setItem('city', this.cityDetails.name)

           
      var route

      if(opt.name == "Tüm İlçeler") {
        route = { name: 'City', params: { slug: this.$route.params.slug } }
      }

      else {


      //et route = { name: 'CityDistrict', params: { slug: slug, district: opt.slug } }
     //  route = '/' + this.$route.params.city + '-' + opt.slug + '-movies/'
      let slug = '/' + this.$route.params.city + '-' + opt.slug + '-movies/'
      route = { name: 'CityDistrict', params: { slug: slug, city:this.$route.params.city, district:opt.slug, district1: opt.name } }
/*       if (this.$route.params.type === 'erkek') {
        route = { name: 'CityDistrictGender', params: { slug: slug, district: opt.slug, type: 'erkek' } }
      } else if (this.$route.params.type === 'kiz') {
        route = { name: 'CityDistrictGender', params: { slug: slug, district: opt.slug, type: 'kiz' } }
      } */

      if (this.$route.params.type) {
        if(this.$route.params.type.includes('erkek')) {
        if(!opt.slug.includes('ilcesi')) {
          route = '/' + this.$route.params.city + '-' + opt.slug + '-movies/'
        } else {
          route = '/' + this.$route.params.city + '-' + opt.slug + '-movies/'
        }
        
        // route = { name: 'UniversityFacultyGender', params: { slug: slug, faculty: opt.slug, type: 'erkek' } }
      } else if (this.$route.params.type === 'kiz' || this.$route.params.type === '-kiz' || this.$route.params.type === '-ozel-kiz' || this.$route.params.type === 'ozel-kiz') {
                if(!opt.slug.includes('ilcesi')) {
         route = '/' + this.$route.params.city + '-' + opt.slug + '-movies/'
        } else {
          route = '/' + this.$route.params.city + '-' + opt.slug + '-tv-shows/'
        }
      }
        // route = { name: 'UniversityFacultyGender', params: { slug: slug, faculty: opt.slug, type: 'kiz' } }
      }

      }
      this.$router.push(route)
      // this.$emit('selectCity', opt)
    },
    filterDistrict (district) {
      return this.cityDetails.districts.find((item) => item.slug === district)
    },
    checkPagination () {
      if (this.currentRouteName === this.$route.name) {
        if (this.$route.params.page > 1) {
          window.scrollTo(0, this.$refs.dormTab.offsetTop)
        }
      }
    }
  },
  computed: {
    ...mapGetters(['cityDetails', 'total_results']),
    getStudios() {
      if(this.$route.params.genre == 'Animation')
      return this.studiosAnimation
      else if (this.$route.params.genre == 'Horror')
      return this.studiosHorror
      else if (this.$route.params.genre == 'Science Fiction')
      return this.studiosSciFi
      else if (this.$route.params.genre == 'Western')
      return this.studiosWestern
      else if (this.$route.params.genre == 'Documentary')
      return this.studiosDocumentary
      else 
      return this.studios      
    },
    getlistseo () {
    if(this.$route.fullPath.includes('ilcesi')) {
      let self = this
      axios.get(`/site/cities/dorms/${this.$route.params.city}?district=${this.$route.params.district}`)
        .then(response => {
          this.list_seo = response.data.district.list_seo
        })
        .catch(e => {
          this.errors.push(e)
        })
      return this.list_seo
    } else {
      return this.cityDetails.list_seo
    }
    
    },    
    /*     getGender() {
      if(this.gender == 'Kız') {
        return 'kiz'
      } else {
        return 'erkek'
      }
    }, */
    pageTitle () {
      let type = 'Movies'
      if (this.gender == 'Erkek') {
        type = 'TV Shows'
      } else {
        type = 'Movies'
      }
      //const studio = window.localStorage.getItem('mail')
      const titleTemplate = this.$route.params.genre
      let title = `<span class="color-light-green">${this.city_name} </span>Özel ${titleTemplate}`
      const route = this.$route.params
      if (route.district) {
        const district = this.filterDistrict(route.district)
        if (type) {
          title = `<span class="color-light-green">${this.city_name} ${district.name} </span>${type} ${titleTemplate}`
        } else {
          title = `<span class="color-light-green">${this.city_name} ${district.name} </span>${titleTemplate}`
        }
      } else if (type) {
         title = `<span class="color-light-green">${titleTemplate} </span> ${type}`
       // title = `<span class="color-light-green">${this.city_name} </span> ${type} ${titleTemplate}`
      }

      return title
    },
    spot () {
      let title = this.cityDetails.spot
      const route = this.$route.params
      if (route.district) {
        const district = this.filterDistrict(route.district)
        if (this.gender === 'Erkek') {
          title = district.male_spot
        } else if (this.gender === 'Kız') {
          title = district.female_spot
        } else {
          title = district.spot
        }
      } else if (this.gender) {
        if (this.gender === 'Erkek') {
          title = this.cityDetails.male_spot
        } else if (this.gender === 'Kız') {
          title = this.cityDetails.female_spot
        }
      }
      return title
    }
  },
  created () {
    this.checkCityDetails()
    this.checkGender()
    this.checkDistrict()
    var myString = this.$route.fullPath
    var lastChar = myString[myString.length -1];
    
    if(lastChar === '/') {
        this.fullPath = this.$route.fullPath
    } else {
      this.fullPath = this.$route.fullPath + '/'
    }

     
  },
  mounted () {
    // this.getCityDetails()
    this.checkPagination()
    this.checkDistrict()
    this.currentRouteName = this.$route.name
    
  },
  watch: {
    $route () {
      this.checkGender()
      this.checkPagination()
      this.checkDistrict()
      
    if(!this.$route.fullPath.includes('ilcesi')) {
      this.district = 'İlçe Seçiniz'
    }
      // this.checkDistrictGender()
    }
  },
  beforeDestroy () {
    // this.$store.dispatch(GET_CITY_DETAILS, null)
  }
}
</script>

<style lang="scss">
  @import "../../assets/scss/components/city";
  @import "../../assets/scss/components/pagination-new";
  @import "../../assets/scss/components/dorm-tab";

  /*.info-card {*/
    /*height: auto !important;*/
  /*}*/

  .wrapper {
    padding-bottom: 170px;
  }

  .dorm-tab__header {
    margin-top: -90px;
  }

  .select__title {
    font-size: 17px !important;
  }
  .city-text p {
    color: #fff !important;
  }

  .mytitle1 {
    font-size: 15px;
    color:white;
  }

  .my {
   // padding: 10px 20px !important;
  //  padding-bottom: 5px;
    bottom: 20px;
  }
</style>
